export const getConvertToPoActionState = ({
  isConverting = false,
  hasConverted = false,
  isBlocked = false,
  allowAdditionalGeneration = false,
  hasRemainingPurchaseOrders = false,
} = {}) => {
  if (isConverting) {
    return { label: "Converting to PO...", disabled: true, status: "converting" };
  }
  if (hasConverted && allowAdditionalGeneration) {
    if (hasRemainingPurchaseOrders) {
      return {
        label: "Generate Remaining POs",
        disabled: !!isBlocked,
        status: "ready",
      };
    }
    return {
      label: "All POs Generated",
      disabled: true,
      status: "converted",
    };
  }
  if (hasConverted) {
    return { label: "Converted to PO", disabled: true, status: "converted" };
  }
  return { label: "Convert To PO", disabled: !!isBlocked, status: "ready" };
};

export const tryBeginConvertToPo = (
  inFlightRef,
  hasConverted,
  { allowAdditionalGeneration = false } = {}
) => {
  if (!inFlightRef || inFlightRef.current) return false;
  if (hasConverted && !allowAdditionalGeneration) return false;
  inFlightRef.current = true;
  return true;
};
